import { initFederation } from '@angular-architects/native-federation';
import './zone-fork-registry'; // Must run after zone.js (loaded as polyfill) and before any Angular bootstrap
import { environment } from './environments/environment';

// Native federation resolves ./remoteEntry.json and import map entries relative to <base href>.
// It requires a trailing slash (e.g. /app-isso/) but the original base-path has no trailing slash.
// Add it here before initFederation runs. Angular's APP_BASE_HREF is set separately in bootstrap
// via computeBaseHref which strips the trailing slash for correct router path matching.
const baseEl = document.querySelector('base');
const originalBase = baseEl?.getAttribute('href') || '/';
if (baseEl && !originalBase.endsWith('/')) {
  baseEl.setAttribute('href', originalBase + '/');
}
const options = environment.production ? { cacheTag: 'remoteEntry.20260819T143313.json' } : {};
console.log({ options });
initFederation({}, options)
  .catch((err) => console.error(err))
  .then((_) => import('./bootstrap').then((m) => m.initAppShell()))
  .catch((err) => console.error(err));
